import GrantAccessModal from './GrantAccessModal.component';

export default GrantAccessModal;